export const collectionListBindingContextId = (id: string) => `c_list_${id}`;
export const collectionTemplateBindingContextId = (id: string) =>
  `c_template_${id}`;

export const fieldBindingContextId = (fieldId: string, collectionId: string) =>
  `f_list_${fieldId}_${collectionId}`;
export const mifBindingContextTypeId = (id: string) => `mif_type_${id}`;
